import { Button, Menu, MenuItem, Typography } from "@mui/material";
import { useAppDispatch } from "hooks/StoreHooks";
import { useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { USERNAME } from "constants/api/localStorage";
import { getLocalStorageOrCookie } from "utils/getLocalStorageOrCookie";
import { logout } from "store/Slices/appStateSlice";
import { connectionApi } from "services/api/connectionApi";
import { useAppSelector } from "store/store";

import "./ConnectedUser.scss";

const ConnectedUserDisplay: React.FC = () => {
  const dispatch = useAppDispatch();
  const token = useRef(useAppSelector(state => state.appState.token));
  const [logoutQuery] = connectionApi.endpoints.logout.useLazyQuery();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  function handleConnectedUserButtonClick(
    event: React.MouseEvent<HTMLElement>
  ): void {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeconnectionClick = async () => {
    await logoutQuery(token);
    dispatch(logout());
  };

  return (
    <>
      <Button
        className="connected-user"
        onClick={handleConnectedUserButtonClick}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        endIcon={<KeyboardArrowDownIcon style={{ color: "white" }} />}>
        <Typography
          style={{
            color: "white",
            textTransform: "none",
          }}>
          Bienvenue {getLocalStorageOrCookie(USERNAME)}
        </Typography>
      </Button>
      <Menu
        className="connected-user"
        open={open}
        id="basic-menu"
        anchorEl={anchorEl}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}>
        <MenuItem onClick={handleDeconnectionClick}>Se déconnecter</MenuItem>
      </Menu>
    </>
  );
};
export default ConnectedUserDisplay;
